import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  input,
  output,
  viewChild,
} from '@angular/core';
import Quill from 'quill';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.html',
  styleUrl: './rich-text-editor.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextEditor implements AfterViewInit, OnDestroy {
  readonly content = input<string>('');
  readonly placeholder = input<string>('');
  readonly readOnly = input<boolean>(false);
  readonly contentChange = output<string>();

  private editorContainer = viewChild.required<ElementRef>('editorContainer');
  private quill: Quill | null = null;

  ngAfterViewInit(): void {
    this.quill = new Quill(this.editorContainer().nativeElement, {
      theme: 'snow',
      placeholder: this.placeholder(),
      modules: {
        toolbar: [[{ header: [1, 2, 3, 4, false] }], ['bold', 'italic'], ['link'], ['clean']],
      },
      formats: ['header', 'bold', 'italic', 'link'],
    });

    if (this.readOnly()) {
      this.quill.enable(false);
    }

    // Set initial content
    const initial = this.content();
    if (initial) {
      this.quill.root.innerHTML = initial;
    }

    // Emit on text change
    this.quill.on('text-change', () => {
      const html = this.quill!.root.innerHTML;
      // Quill emits '<p><br></p>' for empty content
      this.contentChange.emit(html === '<p><br></p>' ? '' : html);
    });
  }

  ngOnDestroy(): void {
    // Quill doesn't have a dedicated destroy, but we can clean up the event listener
    this.quill = null;
  }
}
